import "./XeroPaymentUpdate.scss";
import XeroPaymentUpdate from "../../features/XeroPaymentUpdate/XeroPaymentUpdate";

const XeroPaymentUpdatePage = () => {
  return (
    <div>
      <XeroPaymentUpdate />
    </div>
  );
};

export default XeroPaymentUpdatePage;
